import React from 'react';
import Grid from '@mui/material/Grid';
import Divider from '@mui/material/Divider';
import SummaryDataItem from './SummaryDataItem';
import {
  SHOPPING_CART_SUMMARY_VALUE_CLASS_NAME,
  SHOPPING_CART_SUMMARY_CHILD_VALUE_CLASS_NAME,
} from '../../theme/constants/typography';

/**
 * Renders summary items with support for expandable accordions.
 *
 * To use expandable items:
 * 1. Add an object with `expandable: true` in the summary array
 * 2. All subsequent objects that should be nested inside the accordion must have
 *    `isChild: true`
 * 3. The children will be rendered inside the expandable accordion until a
 *    non-child item is encountered
 */

const createItem = (item, loading, children) => (
  <SummaryDataItem
    title={item.title}
    titleVariant={item.titleVariant}
    titleColor={item.color}
    titleClassName={item.titleClassName}
    value={item.value}
    valueVariant={item.valueVariant}
    valueColor={item.valueColor}
    isMoney={item.money}
    discount={item.discount}
    loading={loading}
    expandable={item.expandable}
    valueClassName={item.isChild
      ? SHOPPING_CART_SUMMARY_CHILD_VALUE_CLASS_NAME
      : SHOPPING_CART_SUMMARY_VALUE_CLASS_NAME}
    fontWeight={item.fontWeight}
  >
    {children}
  </SummaryDataItem>
);

const renderChildren = (summary, startIndex, loading) => {
  const children = [];
  let index = startIndex;

  while (index < summary.length && summary[index].isChild) {
    const item = summary[index];
    children.push(
      <Grid item xs={12} key={`child-${item.title}`}>
        {createItem(item, loading)}
        {item.divider && (
        <Grid item xs={12} sx={{ mt: 1.5 }}>
          <Divider sx={{ borderColor: 'gray.A300', borderWidth: '1px', borderRadius: '10px' }} />
        </Grid>
        )}
      </Grid>,
    );
    index += 1;
  }

  return children;
};

const RenderSummaryItems = (summary, loading) => {
  const items = [];
  summary.forEach((item) => {
    if (item.expandable) {
      items.push(
        <Grid item xs={12} key={`parent-${item.title}`}>
          {createItem(
            item,
            loading,
            renderChildren(summary, summary.indexOf(item) + 1, loading),
          )}
        </Grid>,
      );
    } else if (!item.isChild) {
      items.push(
        <Grid item xs={12} key={`item-${item.title}`}>
          {createItem(item, loading)}
          {item.divider && (
            <Grid item xs={12} sx={{ mt: 1.5 }}>
              <Divider sx={{ borderColor: 'gray.A300', borderWidth: '1px', borderRadius: '10px' }} />
            </Grid>
          )}
        </Grid>,
      );
    }
  });

  return items;
};

export default RenderSummaryItems;
